import React from 'react';
import PropTypes from 'prop-types';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Route } from 'react-router-dom';
import LoadingIndicator from 'ui/LoadingIndicator';

// TODO: Deprecated.
//  ServiceBootstrapper handles the logic now to redirect to the login page all the time.
//  When this component wants to load, the user is always logged in. We should replace
//  all the calls to this component by a simple call to Router,
const PrivateRoute = ({ component, ...args }) => {
  const params = {
    onRedirecting: () => <LoadingIndicator cover />
  };

  return (
    <Route
      component={withAuthenticationRequired(component, params)}
      {...args}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired
};

export default PrivateRoute;
